// eslint-disable-next-line no-undef
const file = PACKAGE_VERSION;

window.basic_auth = {
  version: file.version,
  dependencies: {
    vue: file.dependencies.vue,
    vueRouter: file.dependencies["vue-router"],
    vuex: file.dependencies["vuex"],
    uiKit: file.dependencies["@infocert/ui-kit"],
    spidWcPasswordless: file.dependencies["spid-wc-passwordless-infocert"]
  }
};
